export { default as EmployeeModel } from './EmployeeModel';
export { default as EmployeesGateway } from './EmployeesGateway';
export { default as EmployeesService } from './EmployeesService';
export { default as EmployeesServiceProvider } from './EmployeesServiceProvider';



// WEBPACK FOOTER //
// ./src/api/employees/index.js